import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Person } from "../Entities/Person/Person";
import { PersonInterface } from "../Entities/Person/PersonInterface";
import UserSettingsFactory from "./UserSettingsFactory";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";
import { CompanyInterface } from "../Entities/Company/CompanyInterface";
import CompanyFactory from "./CompanyFactory";
import RoleContainer from "../Entities/Person/Role/RoleContainer";

class PersonFactory extends Factory implements FactoryInterface {
  public create(data: any): PersonInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);
    const companies: CompanyInterface[] = CompanyFactory.createFromArray(data.companies);

    return new Person({
      id: data.id,
      amazonFolderName: data.amazonFolderName,
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      displayName: data.displayName?.trim() || "",
      email: data.email || "",
      newEmail: data.new_email || "",
      agencyId: data.agencyId,
      companyId: data.companyId,
      role: RoleContainer.pickFromId(data.contactRoleId),
      contactStatusId: data.contactStatusId,
      avatar: this.getAvatar(attachments, "user"),
      phone1: data.phone1 || "",
      phone2: data.phone2 || "",
      profession: data.profession || "",
      address: this.generateAddress(data.address),
      attachments: attachments,
      createdAt: new Date(data.createdAt),
      updatedAt: new Date(data.updatedAt),
      removed: data.removed,
      mainBankAccountId: data.mainBankAccountId || "",
      mainBankAccountName: data.mainBankAccountName || "",
      createdBySystem: data.createdBySystem,
      dateOfBirth: data.dateOfBirth === null ? null : new Date(data.dateOfBirth),
      placeOfBirthAddress: data.placeOfBirthAddress || {},
      identityNumber: data.identityNumber || "",
      identityType: data.identityType,
      note: data.note,
      genderTypeId: data.genderTypeId,
      languageTypeId: data.languageTypeId,
      documentAddress: data.documentAddress,
      userSettings: data.userSettings ? UserSettingsFactory.create(data.userSettings[0]) : UserSettingsFactory.create(undefined),
      companies: companies,
      contactForContracts: data.contactForContracts
    });
  }

  public reinitialize(data: any): PersonInterface {
    return new Person({
      ...data,
      avatar: this.getAvatar(data.attachments, "user"),
    });
  }
}

export default new PersonFactory();
